import React from 'react';
import { Segment, Grid } from "semantic-ui-react";

const DevisTotal = ({label, value, dark}) => (
    <Grid.Column className={dark ? "dark" : "light "}>
        <Segment className="totalContent">
            <div className="totalLabel">{label}</div>
            <div className="totalValue">{value}</div>
        </Segment>
    </Grid.Column>
);

export default DevisTotal;


// WEBPACK FOOTER //
// ./src/components/Pro/DevisFactures/EditionDevisFactures/DevisComp/DevisTotal.jsx